module.exports = __webpack_public_path__ + "img/mession-1.bd9c11d5.png";